import tinygradient from 'tinygradient';

const gradient = tinygradient(['#fcb045', '#a27dbb']);
export default function rarityRankColor(v) {
  return gradient.rgbAt(v).toRgbString();
}
